import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CopyText = _resolveComponent("CopyText")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_app_page = _resolveComponent("app-page")!
  const _component_Logger = _resolveComponent("Logger")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_page, { fheader: { showCollapse: false } }, {
      fheader: _withCtx(() => [
        _createVNode(_component_el_form, {
          class: "fixed-el-form-item-height",
          model: _ctx.params,
          "label-width": "110px",
          onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.handleSearch()), ["enter"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "款式号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.params.styleCodeLike,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.styleCodeLike) = $event)),
                  placeholder: "请输入款式号",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "订单号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.params.orderCodeLike,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.orderCodeLike) = $event)),
                  placeholder: "请输入订单号",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { "label-width": "40px" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSearch()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查询")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleReset()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("重置")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      main: _withCtx(({ height }) => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: "",
          height: height,
          key: height,
          data: _ctx.tableData
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "款式号",
              "min-width": "140",
              prop: "styleCode",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_CopyText, null, {
                  default: _withCtx(() => [
                    (_ctx.$has(_ctx.permissionConfig.EDIT) && row.styleCode)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: {
                  name: 'ProductionDemandOrderEdit',
                  params: { id: row.orderId },
                }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(row.styleCode || '-'), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(row.styleCode || '-'), 1))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "客户款号",
              "min-width": "120",
              prop: "customerStyleCode",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "订单号",
              "min-width": "120",
              prop: "orderCode",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "联系人",
              "min-width": "100",
              prop: "contactName",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "生产经理",
              "min-width": "100",
              prop: "directorName",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "生产跟单",
              "min-width": "100",
              prop: "merchandiserName",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "紧急程度",
              "min-width": "100",
              prop: "emergencyLevel",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_ctx.$filters.getEnumLabel(_ctx.EMERGENCY_LEVEL_LIST, row.emergencyLevel)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "交付方式",
              "min-width": "100",
              prop: "deliveryType",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_ctx.$filters.getEnumLabel(_ctx.DELIVERY_TYPE_LIST, row.deliveryType)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "接单主体",
              "min-width": "110",
              prop: "orderMainstayName",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "单量",
              "min-width": "100",
              prop: "quantity",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "本单金额",
              "min-width": "100",
              prop: "orderAmount",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "操作日志",
              "min-width": "100",
              align: "center",
              fixed: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_button, {
                  type: "text",
                  onClick: ($event: any) => (_ctx.handleLog(row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查看日志")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["height", "data"])), [
          [_directive_loading, _ctx.tableLoading]
        ])
      ]),
      ffooter: _withCtx(() => [
        _createVNode(_component_el_row, {
          style: {"width":"100%"},
          type: "flex",
          justify: "end"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_pagination, {
              total: _ctx.tableTotal,
              "current-page": _ctx.params.pageNum,
              size: _ctx.params.pageSize,
              onCurrentChange: _ctx.handleCurrentChange,
              onSizeChange: _ctx.handleSizeChange
            }, null, 8, ["total", "current-page", "size", "onCurrentChange", "onSizeChange"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_Logger, {
      modelValue: _ctx.loggerVisible,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.loggerVisible) = $event)),
      ref: "orderLogRef"
    }, null, 8, ["modelValue"])
  ], 64))
}